import type { ParentProps } from "solid-js"
import {
  tableCellStyle,
  tableHeaderStyle,
  tableRecipe,
  tableRowStyle,
} from "./table.css"

function Table(props: ParentProps) {
  return <table class={tableRecipe()}>{props.children}</table>
}

function Head(props: ParentProps) {
  return (
    <thead>
      <Row>{props.children}</Row>
    </thead>
  )
}

function Body(props: ParentProps) {
  return <tbody>{props.children}</tbody>
}

function Row(props: ParentProps) {
  return <tr class={tableRowStyle}>{props.children}</tr>
}

function Header(props: ParentProps) {
  return <th class={tableHeaderStyle}>{props.children}</th>
}
function Cell(props: ParentProps) {
  return <td class={tableCellStyle}>{props.children}</td>
}

Table.Body = Body
Table.Head = Head
Table.Row = Row
Table.Header = Header
Table.Cell = Cell

export { Table }
